<script setup lang="ts">
import { navLinks } from '../data/landing.content'
import { useLandingScroll } from '../composables/useLandingScroll'

const { scrolled, mobileOpen, toggleMobile, closeMobile, smoothScrollTo } = useLandingScroll()

function onNavClick(href: string) {
  if (href.startsWith('#')) {
    smoothScrollTo(href)
    return
  }
  window.location.assign(href)
}
</script>

<template>
  <nav class="wl-navbar" :class="{ 'wl-is-scrolled': scrolled }" id="navbar">
    <div class="wl-nav-container">
      <a href="#inicio" class="wl-nav-logo" @click.prevent="smoothScrollTo('#inicio')">
        <div class="wl-logo-icon" aria-hidden="true">
          <img src="/images/appmisionate-icon.svg" alt="">
        </div>
        <span><span class="wl-logo-app">App</span>misiónate</span>
      </a>

      <ul class="wl-nav-links">
        <li v-for="link in navLinks" :key="link.href">
          <a :href="link.href" @click.prevent="onNavClick(link.href)">{{ link.label }}</a>
        </li>
      </ul>

      <div class="wl-nav-actions">
        <div class="wl-btn-group">
          <a href="/registrarse" class="wl-btn-group-item">Registrarse</a>
          <span class="wl-btn-group-divider" aria-hidden="true"></span>
          <a href="/login" class="wl-btn-group-item">Iniciar Sesión</a>
        </div>
      </div>

      <button
        class="wl-nav-toggle"
        :class="{ 'wl-is-open': mobileOpen }"
        aria-label="Abrir menú"
        :aria-expanded="mobileOpen"
        aria-controls="mobileMenu"
        @click="toggleMobile"
      >
        <span></span><span></span><span></span>
      </button>
    </div>

    <div class="wl-mobile-menu" :class="{ 'wl-is-open': mobileOpen }" id="mobileMenu">
      <ul>
        <li v-for="link in navLinks" :key="link.href">
          <a :href="link.href" @click.prevent="onNavClick(link.href)">{{ link.label }}</a>
        </li>
      </ul>
      <div class="wl-btn-group wl-btn-group-full">
        <a href="/registrarse" class="wl-btn-group-item">Registrarse</a>
        <span class="wl-btn-group-divider" aria-hidden="true"></span>
        <a href="/login" class="wl-btn-group-item">Iniciar Sesión</a>
      </div>
    </div>
  </nav>
</template>
